import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { getAppStore } from '@/store';

/**
 * @description: Full screen display content
 */
export const useFullContent = () => {
  const appStore = getAppStore();
  const route = useRoute();

  // Whether to display the content in full screen without displaying the menu
  const getFullContent = computed(() => {
    // Query parameters, the full screen is displayed when the address bar has a full parameter
    const query = route.query;
    if (query && Reflect.has(query, '__full__')) {
      return true;
    }
    // Return to the configuration in the configuration file
    return appStore.getProjectConfig.fullContent;
  });

  return { getFullContent };
};
